import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useAuth } from "../AuthProvider";
import TickerSearchBox from "../components/TickerSearchBox";
import StocksPanel from "../components/StocksPanel";

export default function StockDetailPage() {
  const nav = useNavigate();
  const { code } = useParams();
  const selectedCode = (code || "").toUpperCase();

  const { isLoggedIn, userName, userEmail, userRole, handleLogout } = useAuth();
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  return (
    <div className="min-h-screen bg-gray-950 text-gray-100">
      {/* ✅ HEADER (quick fix) */}
      <div className="sticky top-0 z-30 border-b border-gray-700 bg-gray-800/95 backdrop-blur shadow-md">
        <div className="mx-auto w-full max-w-[1400px] px-3 sm:px-4 h-14 flex items-center gap-3">
          <div className="flex items-center gap-2 shrink-0">
            <div
              onClick={() => nav("/")}
              className="text-lg font-semibold text-purple-400 whitespace-nowrap cursor-pointer hover:opacity-80"
            >
              Saham Vista
            </div>            
          </div>

          <div className="w-[180px] sm:w-[260px] md:w-[360px] lg:w-[420px]">
            <TickerSearchBox placeholder="Search kode saham..." />
          </div>

          <div className="flex-1" />

          {isLoggedIn ? (
            <div className="relative">
              <button
                onClick={() => setShowProfileMenu((v) => !v)}
                className="w-9 h-9 rounded-full overflow-hidden border border-gray-600 hover:border-gray-500 focus:outline-none focus:ring-2 focus:ring-purple-500/40"
                title="User Menu"
              >
                <img
                  src={`https://api.dicebear.com/6.x/initials/svg?seed=${userName || userEmail || "User"}`}
                  alt="User Avatar"
                  className="w-full h-full object-cover"
                />
              </button>

              {showProfileMenu && (
                <div className="absolute right-0 mt-2 w-56 bg-gray-800 rounded-lg shadow-xl z-50 border border-gray-700 overflow-hidden">
                  <div className="px-4 py-3 text-sm text-gray-300">
                    <div className="font-semibold truncate">{userName || userEmail}</div>
                    <div className="text-gray-400 text-xs">{userRole}</div>
                  </div>
                  <div className="h-px bg-gray-700" />
                  <button
                    onClick={handleLogout}
                    className="w-full px-4 py-2 text-left text-sm text-red-400 hover:bg-gray-700"
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          ) : null}
        </div>
      </div>

      {/* ✅ BODY: langsung render StocksPanel tapi paksa detail */}
      <main className="mx-auto w-full max-w-[1200px] px-2 sm:px-4 py-2">
        <StocksPanel forceSelectedCode={selectedCode} hideListFilters />
      </main>
    </div>
  );
}
